import { jsx as s } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import { P as d, S as e, T as u, G as b } from "./DecoratedButton-D1hX-3Iw.mjs";
import { A as c } from "../icons/Arrow-DlptGprM.mjs";
const w = () => /* @__PURE__ */ s(c, {}), m = n(
  ({ forwards: r = !0, className: o = "", ...t }, a) => /* @__PURE__ */ s(
    d,
    {
      className: `${o} ${r ? "rds-arrow-button--forwards" : "rds-arrow-button--backwards"}`,
      arrow: w,
      buttonType: "rds-arrow-button",
      ref: a,
      ...t
    }
  )
);
m.displayName = "PrimaryArrowButton";
const y = n(
  ({ forwards: r = !0, className: o = "", ...t }, a) => /* @__PURE__ */ s(
    e,
    {
      className: `${o} ${r ? "rds-arrow-button--forwards" : "rds-arrow-button--backwards"}`,
      arrow: w,
      buttonType: "rds-arrow-button",
      ref: a,
      ...t
    }
  )
);
y.displayName = "SecondaryArrowButton";
const i = n(
  ({ forwards: r = !0, className: o = "", ...t }, a) => /* @__PURE__ */ s(
    u,
    {
      className: `${o} ${r ? "rds-arrow-button--forwards" : "rds-arrow-button--backwards"}`,
      arrow: w,
      buttonType: "rds-arrow-button",
      ref: a,
      ...t
    }
  )
);
i.displayName = "TertiaryArrowButton";
const p = n(
  ({ forwards: r = !0, className: o = "", ...t }, a) => /* @__PURE__ */ s(
    b,
    {
      className: `${o} ${r ? "rds-arrow-button--forwards" : "rds-arrow-button--backwards"}`,
      arrow: w,
      buttonType: "rds-arrow-button",
      ref: a,
      ...t
    }
  )
);
p.displayName = "GhostArrowButton";
export {
  p as G,
  m as P,
  y as S,
  i as T
};
